import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { ConfigIncidentTypeComponent } from './config-incident-type/config-incident-type.component';
import { SocketService } from './services/socket.service';
import { RedirectGuard } from './redirect-guard';

@NgModule({ declarations: [AppComponent, ConfigIncidentTypeComponent],
    bootstrap: [AppComponent], imports: [BrowserModule, IonicStorageModule.forRoot({ name: '1risk' }), IonicModule.forRoot({ animated: false, mode: 'md' }), AppRoutingModule, SharedModule], providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, SocketService, RedirectGuard, provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class AppModule { }
